export const isMoneyVisible = (user) => {
    if (
        user?.OrganizationId === "6478935c63e4e900122e2052" //adny summer
        ) {
        return false
    }
    return true
}

